/* eslint-disable import/prefer-default-export */

export const API_SERVER = process.env.NODE_ENV === 'production' ? 'https://app.vpriem.ru' : 'http://appv2.vpriem.local'; // for prod : local
export const API_HOST = `${API_SERVER}/api/`;
